<template>
  <BLayoutExpansion
    :error="$errors.has(name)"
    :error-messages="$errors.first(name)"
    :extendless="extendless"
  >
    <template #header>
      <slot name="header">
        <TitleWithButton
          :title="title"
          :button-text="buttonText"
          :skeleton="skeleton"
          :creatable="!readonly && creatable"
          class="font-weight-bold"
          @create="onActionCreate"
        />
      </slot>
    </template>

    <slot name="top">
      <BAutocompleteCommon
        v-if="!readonly && typeAutocomplete"
        v-bind="$attrs"
        :value="valueAutocomplete"
        :$type="typeAutocomplete"
        :exclude="value"
        :skeleton="skeleton"
        multiple
        @input="onInput"
        @action:delete="onActionDelete"
      />
    </slot>

    <div style="margin: 0 -16px -8px;">
      <BTableCommon
        v-validate="validate"
        v-bind="$attrs"
        :type="typeTable"
        :list="value"
        :actions="filteredActions"
        :skeleton="skeleton"
        :name="name"
        :data-vv-as="`«${dataVvAs || title}»`"
        v-on="$listeners || {}"
        @action:delete="onActionDelete"
      >
        <template v-for="(_, key) in scopedSlots" #[key]="props">
          <slot v-bind="props" :name="key" />
        </template>
      </BTableCommon>
    </div>
  </BLayoutExpansion>
</template>

<script>
import uniqueId from 'lodash/uniqueId'
import { CREATE } from '@/helpers/enums/view-types'

import BAutocompleteCommon from '@/components/forms/BAutocompleteCommon.vue'
import BTableCommon from '@/components/tables/BTableCommon.vue'
import TitleWithButton from '@/components/common/TitleWithButton.vue'
import BLayoutExpansion from './BLayoutExpansion.vue'


export default {
  name: 'BLayoutExpansionTable',
  inject: ['$validator'],
  components: {
    BLayoutExpansion,
    BAutocompleteCommon,
    BTableCommon,
    TitleWithButton,
  },
  inheritAttrs: false,
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    skeleton: Boolean,
    extendless: Boolean,
    value: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    dataVvAs: String,
    readonly: Boolean,
    creatable: Boolean,
    validate: [String, Object],
    name: {
      type: String,
      default: uniqueId('b-layout-expansion-table-'),
    },
    typeAutocomplete: {
      type: String,
      // required: true,
    },
    typeTable: {
      type: String,
      required: true,
    },
    actions: Array,
    buttonText: {
      type: String,
      default: 'Добавить',
    },
  },
  data: () => ({
    valueAutocomplete: [],
  }),
  computed: {
    scopedSlots() {
      const scopedSlots = { ...this.$scopedSlots }
      delete scopedSlots.header
      return scopedSlots
    },
    filteredActions() {
      return this.readonly ? [] : this.actions
    },
  },
  methods: {
    onInput(data) {
      if (!data) return
      const value = [].concat(data, this.value)
      this.$emit('input', value)
      this.$nextTick(() => {
        this.valueAutocomplete = []
      })
    },
    onActionCreate() {
      this.$emit(`action:${CREATE}`)
    },
    onActionDelete(data) {
      const value = this.value.slice()
      const index = value.indexOf(data)
      value.splice(index, 1)
      this.$emit('input', value)
    },
  },
}
</script>
